import { location } from '../utils/navigation';

import { PRODUCTION_ENV, RELEASE_RC } from './constants';
import { Environment, getEnvConfig } from './env-configs';

/*
 * MOCK_SERVER_DATA
 * option for toggling from real server to mocks
 * true - enable the mock transport for all project
 * false (default value) - enable the real API for all project
 * */
const MOCK_SERVER_DATA = false;

const PREFIX = '/platform';

function getCurrentEnv(): Environment {
  if (
    location.getQueryParameters() &&
    location.getQueryParameters().test === 'true'
  ) {
    return Environment.e2eTest;
  }

  switch (window.__ENV__) {
    case PRODUCTION_ENV:
      return window.__RELEASE__ === RELEASE_RC
        ? Environment.Testing
        : Environment.Production;

    default:
      return MOCK_SERVER_DATA
        ? Environment.mockedDevelopment
        : Environment.Development;
  }
}

export const NAVIGATION = {
  HOME_STATE: '/',
  LOGIN_STATE: `${PREFIX}/login`,
  EXTERNAL_USER: `${PREFIX}/external-user`,
  MEDIA_ASSETS: `${PREFIX}/organization/:organizationId/:projectId/media-assets`,
  FILE_MANAGER: `${PREFIX}/organization/:organizationId/:projectId/file-manager`,

  PROJECT_OVERVIEW: `${PREFIX}/organization/:organizationId/:projectId/overview`,

  LIVE_STREAMS: `${PREFIX}/organization/:organizationId/:projectId?/live-streams`,
  APPLICATION_STATE: `${PREFIX}/organization/:organizationId/:projectId?/applications/:applicationId?`,
  APPLICATION_OVERVIEW_STATE: `${PREFIX}/organization/:organizationId/:projectId?/applications/:applicationId?/overview`,
  MEMBERS_STATE: `${PREFIX}/organization/:organizationId/members`,
  PROJECTS_STATE: `${PREFIX}/organization/:organizationId/projects`,
  TEAM_STATE: `${PREFIX}/organization/:organizationId/team`,
  FLOWS_STATE: `${PREFIX}/organization/:organizationId/:projectId/flows`,

  ORGANIZATION_CREATE_STATE: `${PREFIX}/organization/create`,
  ORGANIZATION_CREATE_FIRST_STATE: `${PREFIX}/organization/first`,
  ORGANIZATION_SELECT_STATE: `${PREFIX}/organization/select`,

  REPLICATIONS_STATE: `${PREFIX}/organization/:organizationId/:projectId/replications`,
  JOBS_STATE: `${PREFIX}/organization/:organizationId/:projectId/jobs`,

  SUPPORT_URL: 'https://support.wixmp.com/',
  WIX_COM_URL: 'https://wix.com',
  CONTACT_US_URL: 'https://support.wixmp.com/en/contact',

  DOCUMENTATION_GETTING_STARTED_URL:
    'https://support.wixmp.com/en/getting-started',
  DOCUMENTATION_SDK_AND_API_URL: 'https://support.wixmp.com/en/sdk-api',
  DOCUMENTATION_KNOWLEDGE_BASE_URL: 'https://support.wixmp.com',
  DOCUMENTATION_PRICING_URL:
    'https://support.wixmp.com/en/article/pricing-billing-5924287',

  EMBED_VIDEO_PLAYER_SUPPORT:
    'https://support.wixmp.com/en/article/embed-video-player',

  APP_PERMISSIONS: `${PREFIX}/organization/:organizationId/app-permissions`,
};

// TODO: get rid of this in favor of using config
export const isTestEnvironment = (): boolean => {
  return window.__ENV__ !== PRODUCTION_ENV;
};

export const getConfig = () => getEnvConfig(getCurrentEnv());
